import { makeStyles } from "tss-react/mui";

const useStyles = makeStyles()((theme) => ({
  mainContainer: {
    width: "100%",
  },
  leftContainer: {
    boxSizing: "border-box",
    display: "flex",
    flexDirection: "column",
    alignItems: "left",
    position: "relative",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  fieldStyle: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#000000",
    marginBottom: "5px",
  },
  planText: {
    display: "flex",
    fontFamily: "Poppins",
    fontWeight: "600",
    fontSize: "20px",
  },
  rightContainer: {
    display: "flex",
    height: "fit-content",
    flexDirection: "column",
    boxSizing: "border-box",
    background: "#f5f5f5",
    padding: "24px 30px",
    width: "35%",
    borderRadius: "4px",
    fontSize: "14px",
    lineHeight: "22px",
    [theme.breakpoints.down("md")]: {
      width: "100%",
    },
  },
  rightContainerHead: {
    fontWeight: "600",
    fontSize: "14px",
    lineHeight: "22px",
    margin: "16px 0",
  },
  subscriptionHeader: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
  },
  pricePerIntevalBox: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "space-between",
    alignItems: "flex-end",
    marginBottom: "10px",
    // alignItems: "flex-end",
    // position: "absolute",
    // right: "33px",
  },
  pricePerIntevalText: {
    fontFamily: "Poppins",
    fontWeight: "700",
    fontSize: "20px",
    color: "#272525",
  },
  pricePerIntevalText2: {
    color: "#999",
  },
  changePlanBtn: {
    borderRadius: "6px",
    border: "1px solid #4D1277",
    //
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "14px",
    color: "#4D1277",
    background: "white",
    cursor: "pointer",
    textTransform: "capitalize",
    //
    width: "fit-content",
    transitionDuration: ".2s",
    transitionProperty: "border,color,background-color",
    transitionTimingFunction: "cubic-bezier(.64,0,.35,1)",
    "&:hover": {
      backgroundColor: "#4d1277",
      color: "white",
    },
    alignSelf: "flex-start",
    padding: "0 7px",
  },
  saveAnnuallyText: {
    fontFamily: "Poppins",
    fontSize: "14px",
    fontWeight: "600",
    color: "green",
    textAlign: "left",
    cursor: "pointer",
  },
  noOfAgentsText: {
    fontFamily: "Poppins",
    fontWeight: "400",
    fontSize: "16px",
    color: "#999",
  },
}));

export default useStyles;
